import styled from 'styled-components'

export default styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  .title {
    margin-top: 20px;
    font-family: 'Open Sans';
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #555555;
  }
`
